// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/TrackingSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/TrackingSortBy.proto.
 */
export const file_Enumerations_TrackingSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiFFbnVtZXJhdGlvbnMvVHJhY2tpbmdTb3J0QnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKr0ECg5UcmFja2luZ1NvcnRCeRIgChxUUkFDS0lOR19TT1JUX0JZX1VOU1BFQ0lGSUVEEAASJgoaVFJBQ0tJTkdfU09SVF9CWV9URU5BTlRfSUQQAxoGysfNDwEDEiQKGFRSQUNLSU5HX1NPUlRfQllfVVNFUl9JRBAEGgbKx80PAQQSJgoaVFJBQ0tJTkdfU09SVF9CWV9VU0VSX05BTUUQBRoGysfNDwEFEi0KIVRSQUNLSU5HX1NPUlRfQllfVFJBQ0tJTkdfS0lORF9JRBAGGgbKx80PAQYSLwojVFJBQ0tJTkdfU09SVF9CWV9UUkFDS0lOR19LSU5EX05BTUUQBxoGysfNDwEHEicKG1RSQUNLSU5HX1NPUlRfQllfUFJPSkVDVF9JRBAIGgbKx80PAQgSKQodVFJBQ0tJTkdfU09SVF9CWV9QUk9KRUNUX05BTUUQCRoGysfNDwEJEicKG1RSQUNLSU5HX1NPUlRfQllfU1RBUlRFRF9BVBAKGgbKx80PAQoSJQoZVFJBQ0tJTkdfU09SVF9CWV9FTkRFRF9BVBALGgbKx80PAQsSKAobVFJBQ0tJTkdfU09SVF9CWV9DUkVBVEVEX0FUEGQaB8rHzQ8CZAESKQocVFJBQ0tJTkdfU09SVF9CWV9NT0RJRklFRF9BVBBlGgfKx80PAmQCEigKG1RSQUNLSU5HX1NPUlRfQllfREVMRVRFRF9BVBBmGgfKx80PAmQDIgQIARABIgQIAhACIgQIDBBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort trackings by.
 *
 * @generated from enum time_tracking.enumerations.TrackingSortBy
 */
export enum TrackingSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: TRACKING_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the trackings by their tenant id.
   *
   * @generated from enum value: TRACKING_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the trackings by the GUIDs of the users they belong to.
   *
   * @generated from enum value: TRACKING_SORT_BY_USER_ID = 4;
   */
  USER_ID = 4,

  /**
   * Sort the trackings by the names of the users they belong to.
   *
   * @generated from enum value: TRACKING_SORT_BY_USER_NAME = 5;
   */
  USER_NAME = 5,

  /**
   * Sort the trackings by the GUIDs of the kind of trackings they represent.
   *
   * @generated from enum value: TRACKING_SORT_BY_TRACKING_KIND_ID = 6;
   */
  TRACKING_KIND_ID = 6,

  /**
   * Sort the trackings by the names of the kind of trackings they represent.
   *
   * @generated from enum value: TRACKING_SORT_BY_TRACKING_KIND_NAME = 7;
   */
  TRACKING_KIND_NAME = 7,

  /**
   * Sort the trackings by the GUIDs of the projects they have been assigned to, if any.
   *
   * @generated from enum value: TRACKING_SORT_BY_PROJECT_ID = 8;
   */
  PROJECT_ID = 8,

  /**
   * Sort the trackings by the names of the projects they have been assigned to, if any.
   *
   * @generated from enum value: TRACKING_SORT_BY_PROJECT_NAME = 9;
   */
  PROJECT_NAME = 9,

  /**
   * Sort the trackings by the date and times they were started at.
   *
   * @generated from enum value: TRACKING_SORT_BY_STARTED_AT = 10;
   */
  STARTED_AT = 10,

  /**
   * Sort the trackings by the date and times they were ended at, if any.
   *
   * @generated from enum value: TRACKING_SORT_BY_ENDED_AT = 11;
   */
  ENDED_AT = 11,

  /**
   * Sort the trackings by their creation time stamp.
   *
   * @generated from enum value: TRACKING_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the trackings by their modification time stamp.
   *
   * @generated from enum value: TRACKING_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the trackings by their deletion time stamp.
   *
   * @generated from enum value: TRACKING_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.TrackingSortBy.
 */
export const TrackingSortBySchema: GenEnum<TrackingSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_TrackingSortBy, 0);

